import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", y = 32 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <p className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-amber-500 flex items-center gap-3">
        <span className="inline-block w-8 h-px bg-amber-500/70" />
        {children}
    </p>
);

export default FadeUp;
